// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.type{
  border-radius: 8px;
  color: rgb(0, 0, 0);
  margin-left: 5px;
}

.types{
  float: right;
}

.bug{
  background-color: rgb(113, 159, 63);
}

.dragon{
  background: linear-gradient(180deg, #53a4cf 50%, #f16e57 50%);
}

.fairy{
  background-color: #fdb9e9;
}

.fire{
  background-color: #fd7d24;
}

.ghost{
  background-color: #7b62a3;
}

.ground{
  background: linear-gradient(180deg, #f7de3f 50%, #ab9842 50%);
}

.normal{
  background: linear-gradient(180deg, #a4acaf 50%, #a4acaf 50%);
}

.psychic{
  background-color: #f366b9;
}

.steel{
  background-color: #9eb7b8;
}

.dark{
  background-color: #707070;
}

.electric{
  background-color: #eed535;
}

.fighting{
  background-color: #d56723;
}

.flying{
  background: linear-gradient(180deg, #3dc7ef 50%, #bdb9b8 50%);
}

.grass{
  background-color: #9bcc50;
}

.ice{
  background-color: #51c4e7;
}

.poison{
  background-color: #b97fc9;
}

.rock{
  background-color: #a38c21;
}

.water{
  background-color: #4592c4;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.type{\n  border-radius: 8px;\n  color: rgb(0, 0, 0);\n  margin-left: 5px;\n}\n\n.types{\n  float: right;\n}\n\n.bug{\n  background-color: rgb(113, 159, 63);\n}\n\n.dragon{\n  background: linear-gradient(180deg, #53a4cf 50%, #f16e57 50%);\n}\n\n.fairy{\n  background-color: #fdb9e9;\n}\n\n.fire{\n  background-color: #fd7d24;\n}\n\n.ghost{\n  background-color: #7b62a3;\n}\n\n.ground{\n  background: linear-gradient(180deg, #f7de3f 50%, #ab9842 50%);\n}\n\n.normal{\n  background: linear-gradient(180deg, #a4acaf 50%, #a4acaf 50%);\n}\n\n.psychic{\n  background-color: #f366b9;\n}\n\n.steel{\n  background-color: #9eb7b8;\n}\n\n.dark{\n  background-color: #707070;\n}\n\n.electric{\n  background-color: #eed535;\n}\n\n.fighting{\n  background-color: #d56723;\n}\n\n.flying{\n  background: linear-gradient(180deg, #3dc7ef 50%, #bdb9b8 50%);\n}\n\n.grass{\n  background-color: #9bcc50;\n}\n\n.ice{\n  background-color: #51c4e7;\n}\n\n.poison{\n  background-color: #b97fc9;\n}\n\n.rock{\n  background-color: #a38c21;\n}\n\n.water{\n  background-color: #4592c4;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
